import PageLoader from '@/components/loader';
import useAuth from '@/hooks/use-auth';
import { Navigate, Outlet } from 'react-router-dom';

const AuthRoute = () => {
    const { data, isLoading } = useAuth();
    const user = data?.data?.user;

    if (isLoading) {
        return <PageLoader />;
    }

    return user ? (
        <Outlet />
    ) : (
        <Navigate
            to={'/'}
            replace
        />
    );
};

export default AuthRoute;
